import { FormEndAdornmentTypes } from "../../../constants/Form";
import ClearEndAdornment from "./ClearEndAdornment/ClearEndAdornment";

const endAdornmentMap = {
  [FormEndAdornmentTypes.Clear]: ClearEndAdornment,
};

export const getEndAdornment = (endAdornmentType: FormEndAdornmentTypes) =>
  endAdornmentMap[endAdornmentType];
